const compareArrays = (array1: any[], array2: any[]) : boolean => {
    // console.log( array1, array2 )
    const array2Sorted = array2?.slice().sort()
    return array1?.length === array2?.length && array1?.slice().sort().every((value, index) => {
        // console.log( value, array2Sorted[index] )
        return value === array2Sorted[index]
    });
}
export default compareArrays

export const separateArrays = (arr1: any[], arr2: any[]) : boolean => { 
    // Сортируем копии массивов
    const sortedArr1 = arr1.map(a => JSON.stringify(a)).slice().sort()
    const sortedArr2 = arr2.map(a => JSON.stringify(a)).slice().sort()

    // Сравниваем поэлементно
    for (let i = 0; i < sortedArr1.length; i++) {
        if ( sortedArr1[i] === sortedArr2[i] ) return true
    }

    return false
}

export const onlyExistsArrays = (arr1: any[], arr2: any[]) : boolean => { 
    // Сортируем копии массивов
    const sortedArr1 = arr1.map(a => JSON.stringify(a)).slice().sort()
    const sortedArr2 = arr2.map(a => JSON.stringify(a)).slice().sort()

    return sortedArr1.some(element => sortedArr2.includes(element));
}